import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Shield, CheckCircle, ExternalLink, Loader2 } from 'lucide-react';
import { getAccessToken } from '@/Backend/services/authService';
import { CONFIG } from '@/config/environment';
import axios from 'axios';
import styles from './PrivacyPolicyModal.module.css';

const API_BASE_URL = CONFIG.BACKEND_URL;

interface PrivacyPolicyModalProps {
  onAccept: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ onAccept }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAccept = async () => {
    setIsSubmitting(true);
    setError(null);

    try {
      const token = getAccessToken();
      if (!token) {
        setError('Sessão expirada. Por favor, faça login novamente.');
        return;
      }

      const response = await axios.post(
        `${API_BASE_URL}/backend/privacy-policy/accept/`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.status === 'success') {
        onAccept();
      }
    } catch (err) {
      console.error('Erro ao aceitar política:', err);
      setError('Erro ao guardar. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.iconContainer}>
          <Shield className={styles.icon} size={40} />
        </div>

        <h2 className={styles.title}>Política de Privacidade</h2>

        <p className={styles.description}>
          Para continuar a usar o PadelMaster, precisa de aceitar a nossa Política de Privacidade.
        </p>

        <p className={styles.summary}>
          Protegemos os seus dados pessoais e usamo-los apenas para melhorar a sua experiência
          na plataforma, conforme o RGPD.
        </p>

        <a
          href="/profile#privacy-policy"
          target="_blank"
          className={styles.readMore}
        >
          <ExternalLink size={16} />
          Ler Política de Privacidade completa
        </a>

        {error && (
          <p className={styles.error}>{error}</p>
        )}

        <Button
          onClick={handleAccept}
          disabled={isSubmitting}
          className={styles.acceptButton}
        >
          {isSubmitting ? (
            <Loader2 className="w-5 h-5 animate-spin mr-2" />
          ) : (
            <CheckCircle className="w-5 h-5 mr-2" />
          )}
          Aceitar e Continuar
        </Button>

        <p className={styles.note}>
          Ao aceitar, concorda com o tratamento dos seus dados conforme descrito na política.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
